export const VALID_REGIONS = [
    "a coruna",
    "albacete",
    "alicante",
    "almeria",
    "araba",
    "asturias",
    "avila",
    "badajoz",
    "baleares",
    "barcelona",
    "bizkaia",
    "burgos",
    "caceres",
    "cadiz",
    "cantabria",
    "castellon",
    "ceuta",
    "ciudad real",
    "cordoba",
    "cuenca",
    "gipuzkoa",
    "girona",
    "granada",
    "guadalajara",
    "huelva",
    "huesca",
    "jaen",
    "la rioja",
    "las palmas",
    "leon",
    "lleida",
    "lugo",
    "madrid",
    "malaga",
    "melilla",
    "murcia",
    "navarra",
    "ourense",
    "palencia",
    "pontevedra",
    "salamanca",
    "santa cruz de tenerife",
    "segovia",
    "sevilla",
    "soria",
    "tarragona",
    "teruel",
    "toledo",
    "valencia",
    "valladolid",
    "zamora",
    "zaragoza",
];

const REGION_LABELS = {
    "a coruna": "A Coruna",
    "almeria": "Almeria",
    "araba": "Araba",
    "avila": "Avila",
    "bizkaia": "Bizkaia",
    "caceres": "Caceres",
    "cadiz": "Cadiz",
    "castellon": "Castellon",
    "cordoba": "Cordoba",
    "gipuzkoa": "Gipuzkoa",
    "huesca": "Huesca",
    "jaen": "Jaen",
    "la rioja": "La Rioja",
    "las palmas": "Las Palmas de Gran Canaria",
    "malaga": "Malaga",
    "santa cruz de tenerife": "Santa Cruz de Tenerife",
};

// Helper para normalizar input a canonical
export function normalizeRegion(input) {
    if (!input) return null;
    const lower = String(input).trim().toLowerCase().replace(/_/g, " ");
    return VALID_REGIONS.includes(lower) ? lower : null;
}

export function formatRegionLabel(input) {
    const normalized = normalizeRegion(input) || String(input || "").trim().toLowerCase().replace(/_/g, " ");
    if (!normalized) return "";
    if (REGION_LABELS[normalized]) return REGION_LABELS[normalized];
    return normalized
        .split(" ")
        .map((part) => part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : "")
        .join(" ");
}
